/**
 * For performance reasons, we should use the built in browser utilities when they are available. This keeps runtime
 * performance optimal as well as reduces bundle size
 */
export const base64Encoder = {
    atob: (input) => window.atob(input),
    btoa: (input) => window.btoa(input),
};
//# sourceMappingURL=base64EncoderBrowser.js.map